
const SettingsStateView = {
  WAREHOUSE_ORDER: {key: "WAREHOUSE_ORDER",url: '/settings/states/warehouse-order', t:'webapp:settings.title.warehouseOrder'},
  INCOMING_ORDER: {key: "INCOMING_ORDER", url: '/settings/states/incoming-order', t:'webapp:settings.title.incomingOrder'},
  SHIPMENT: {key: "SHIPMENT", url: '/settings/states/shipment', t:'webapp:settings.title.shipment'},
  OUTCOMING_ORDER: {key: "OUTCOMING_ORDER", url: '/settings/states/outcoming-order', t:'webapp:settings.title.outcomingOrder'},
};
export default SettingsStateView;